import Route from 'cio/routes/base';
import { all } from 'rsvp';
import { inject as service } from '@ember/service';

import AuthService from 'cio/services/auth';
import AccountService from 'cio/services/account';
import Transition from '@ember/routing/-private/transition';
import UserModel from 'cio/models/user';
import DS from 'ember-data';

export interface Authenticated2faSetupRouteModel {
  user: UserModel;
  secret: string;
  codes: string[];
}

export default class Authenticated2faSetup extends Route {
  @service auth!: AuthService;
  @service account!: AccountService;
  @service store!: DS.Store;

  model(): Promise<Authenticated2faSetupRouteModel> {
    let account = this.account.current;
    let user = account.belongsTo('currentUser').value() as UserModel | null;

    if (user == null) {
      return Promise.reject(new Error('Current user not set on the current account'));
    }

    return all([user.generateNewTwoFactorAuthenticationBackupCodes(), user.getTwoFactorAuthenticationSecret({})]).then(
      ([codes, { secret }]) => ({
        user: user!,
        secret,
        codes,
      }),
    );
  }

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);

    // it's possible that this route is entered with account.current.twoFactorAuthenticationRequired flag out of date, due to recent setting change by another logged-in user
    // refresh the account model to be sure that it contains the correct value
    await this.store.queryRecord('account', {});

    if (!this.account.current.twoFactorAuthenticationRequired || this.auth.user?.twoFactorAuthenticationEnabled) {
      return this.router.transitionTo('authenticated');
    }
    return;
  }
}

declare module '@ember/controller' {
  interface Registry {
    'authenticated/2fa-setup': Authenticated2faSetup;
  }
}
